// Реестр дизайнерских лендингов турниров (доп. услуга): id турнира → компонент.
// Классическая страница любого из них остаётся доступной по ?view=classic.
// Модуль лёгкий: lazy() не тянет чанки, пока лендинг не отрисован, поэтому его
// можно импортировать и в глобальные компоненты (переключатель языка).
import { lazy } from "react";

const GraceCupLanding = lazy(() => import("./GraceCupLanding"));
const AlmaCupLanding = lazy(() => import("./AlmaCupLanding"));
const QueenOfAutumnLanding = lazy(() => import("./QueenOfAutumnLanding"));
const DarCupLanding = lazy(() => import("./DarCupLanding"));
const LiderCupLanding = lazy(() => import("./LiderCupLanding"));
const AlemCupLanding = lazy(() => import("./AlemCupLanding"));
const AutumnLeavesLanding = lazy(() => import("./AutumnLeavesLanding"));
const ZootopiaGymLanding = lazy(() => import("./ZootopiaGymLanding"));
const KhanCupLanding = lazy(() => import("./KhanCupLanding"));
const AliyaWinterCupLanding = lazy(() => import("./AliyaWinterCupLanding"));
const AlemDubaiLanding = lazy(() => import("./AlemDubaiLanding"));
const YoungWingsLanding = lazy(() => import("./YoungWingsLanding"));
const PearlsLanding = lazy(() => import("./PearlsLanding"));
const DisneyCupLanding = lazy(() => import("./DisneyCupLanding"));
const CinderellaCupLanding = lazy(() => import("./CinderellaCupLanding"));
const GrandCupLanding = lazy(() => import("./GrandCupLanding"));
const KinderCupLanding = lazy(() => import("./KinderCupLanding"));
const GraciaVostokaLanding = lazy(() => import("./GraciaVostokaLanding"));
const EliteWinterCupLanding = lazy(() => import("./EliteWinterCupLanding"));

export const TOURNAMENT_LANDINGS: Record<number, React.ComponentType<{ tournament: any }>> = {
  27: GraceCupLanding,
  43: AlmaCupLanding,
  34: QueenOfAutumnLanding,
  35: DarCupLanding,
  33: LiderCupLanding,
  45: AlemCupLanding,
  44: AutumnLeavesLanding,
  46: ZootopiaGymLanding,
  48: KhanCupLanding,
  50: AliyaWinterCupLanding,
  51: AlemDubaiLanding,
  57: YoungWingsLanding,
  58: PearlsLanding,
  59: DisneyCupLanding,
  60: CinderellaCupLanding,
  62: GrandCupLanding,
  63: KinderCupLanding,
  64: GraciaVostokaLanding,
  66: EliteWinterCupLanding,
};

// У каждого лендинга свой переключатель языка в шапке — глобальная плавающая
// «пилюля» на этих страницах не показывается (она перекрывала кнопки шапки).
export const LANDING_TOURNAMENT_IDS = new Set(Object.keys(TOURNAMENT_LANDINGS).map(Number));

/**
 * Классическая страница турнира вместо лендинга: явный ?view=classic или
 * прямая ссылка на вкладку (?tab=protocol из QR-кода и «Поделиться протоколом»).
 * Одна проверка на страницу турнира и на глобальный переключатель языка —
 * иначе они расходятся и переключатель пропадает.
 */
export function wantsClassicTournamentView(search: string = typeof window !== "undefined" ? window.location.search : ""): boolean {
  const q = new URLSearchParams(search);
  return q.get("view") === "classic" || !!q.get("tab");
}
